export default IconTextSpellcheck => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-text-spellcheck" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M5 15v-7.5a3.5 3.5 0 0 1 7 0v7.5" />
  <path d="M5 10h7" />
  <path d="M10 18l3 3l7 -7" />
</svg>`;